import {parseURLQuery, stringifyToURLQuery} from 'app/utils/location/parseURLQuery';
import {URL_PARAMS_SESSION_KEY} from 'app/utils/storage/constants';
import {Parameters} from 'app/utils/storage/types';

export function saveToStorage(params: Parameters) {
    window.sessionStorage.setItem(URL_PARAMS_SESSION_KEY, JSON.stringify(params.values));

    if (params.hide.length === 0) {
        return;
    }

    const url = new URL(window.location.toString());
    const hashParams = parseURLQuery(url.hash.substring(1));
    const hashHasHiddenParams = params.hide.some((name) => name in hashParams);

    params.hide.forEach((name) => {
        url.searchParams.delete(name);
    });

    if (hashHasHiddenParams) {
        url.hash = stringifyToURLQuery(removeHiddenParameters(params.hide, hashParams));
    }

    window.history.pushState({path: url.toString()}, document.title, url.toString());
}

function removeHiddenParameters(toHide: Parameters['hide'], params: Record<string, string>) {
    return Object.keys(params).reduce((result, key) => {
        if (toHide.includes(key)) {
            return result;
        }

        return {
            ...result,
            [key]: params[key],
        };
    }, {});
}
